import React, { Component, useState } from 'react';
import { useGetOrderListMinimal } from '../../hooks/useOrders';
import style from './index.module.css';
import { Select, Row, Col, Tag } from 'antd';
import stl from 'string-to-color';

export default function OrderDropdown({ selectedCompanies = [], onChange }) {
    const [selectedOrders, setSelectedOrders] = useState('');
    console.log(selectedCompanies);

    const {
        data: ordersList,
        isFetching: isFetchingOrders,
        isFetched: isFetchedOrders,
        refetch: refetchOrders,
    } = useGetOrderListMinimal(selectedCompanies);

    return (
        <>
            <div>
                <Select
                    loading={isFetchingOrders}
                    mode="single"
                    allowClear
                    className={style.select}
                    placeholder={'Select Order'}
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{ minWidth: '350px' }}
                    style={{
                        minWidth: 350,
                    }}
                    disabled={selectedCompanies?.length == 0}
                    size="small"
                    options={ordersList?.map(order => {
                        return {
                            label: (
                                <>
                                    <Row>
                                        <Col
                                            flex="60px"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-end',
                                            }}
                                        >
                                            <Tag color={stl(order?.companyCode)}>{order?.companyCode}</Tag>
                                        </Col>
                                        <Col flex="auto" style={{}}>
                                            {order?.name}
                                        </Col>
                                    </Row>
                                </>
                            ),
                            searchBy: `[${order?.companyCode}] : ${order?.name}`,
                            value: order?._id,
                        };
                    })}
                    value={selectedOrders}
                    optionFilterProp="searchBy"
                    listItemHeight={10}
                    listHeight={550}
                    maxTagCount={1}
                    maxTagTextLength={10}
                    onChange={(value, item) => {
                        setSelectedOrders(value);
                        onChange(item);
                    }}
                    onClear={() => setSelectedOrders('')}
                    showSearch
                />
            </div>
        </>
    );
}
